import { mutatorAction } from 'satcheljs';
import { getNotificationSettingsStore } from '../store/store';

export const resetBackupNotificationSettings = mutatorAction(
    'REST_BACKUP_NOTIFICATION_SETTINGS',
    () => {
        let store = getNotificationSettingsStore();
        store.backupSettings = store.settings;
    }
);
